import React from 'react';
import { Link } from 'react-router-dom';
import './partners.css';
import { connect } from 'react-redux';
import {
  updatePartnerFilter,
  updateSelectedPartner
} from '../../../actions/adminActions/partnersActions';
import { partners } from '../../../apis/backend'; //make sure to include this for each page
import EditPartnerModal from './partnerModals/editPartnerModal.jsx';
import AddPartnerModal from './partnerModals/addPartnerModal.jsx';

class Partners extends React.Component {
  async partnerDeleteRequest(id) {
    await partners
      .delete(`/${id}`, {
        headers: { authorization: this.props.employeeToken }
      })
      .catch((response) => {
        console.log(response);
      });
  }

  renderpartners() {
    //renders the partners table
    return (
      <>
        {this.props.partners
          .filter((partner) => {
            const filterString = `${partner.name}`;
            return filterString.toLowerCase().indexOf(this.props.partnerFilter.toLowerCase()) > -1;
          })
          .map((partner) => (
            <tr key={this.props.partners.indexOf(partner)}>
              <td className="text-center" style={{ width: '24%' }}>
                {`${partner.name}`}
              </td>
              <td className="text-center" style={{ width: '9%' }}>
                <Link
                  to="/admin/partneractivities"
                  id={'partner_' + partner.id}
                  className="btn btn-sm btn-dark"
                  onClick={() => {
                    this.props.updateSelectedPartner(partner.id);
                  }}
                >
                  Activities
                </Link>
              </td>
              <td className="text-center permission-super-admin " style={{ width: '9%' }}>
                <div
                  data-target="#exampleModal"
                  className="btn btn-sm btn-dark"
                  data-toggle="modal"
                  onClick={() => {
                    this.props.updateSelectedPartner(partner.id);
                  }}
                >
                  Edit
                </div>
              </td>
              <td className="text-center permission-super-admin " style={{ width: '9%' }}>
                <div
                  className="btn btn-sm btn-dark"
                  data-target="#deleteModal"
                  data-toggle="modal"
                  onClick={() => {
                    this.props.updateSelectedPartner(partner.id);
                  }}
                >
                  Remove
                </div>
              </td>
            </tr>
          ))}
      </>
    );
  }

  getPartnerName() {
    const partner = this.props.partners.find((obj) => obj.id === this.props.selectedPartner);

    return partner ? partner.name : '';
  }

  render() {
    return (
      <div className="partners-page">
        <div className="container">
          <div
            className="form-inline md-form form-sm mt-4"
            style={{ fontSize: '36px', color: '#fff' }}
          >
            <div style={{ margin: 'auto', height: '48px', width: '100%' }}>Partners</div>
          </div>
          <div className="form-inline md-form form-sm mt-3">
            <input
              value={this.props.partnerFilter}
              className="form-control form-control-lg w-45"
              type="text"
              placeholder="Search"
              aria-label="Search"
              onChange={(e) => {
                this.props.updatePartnerFilter(e.target.value);
              }}
            />
            <div
              data-target="#addModal"
              className="btn btn-lg btn-dark permission-super-admin"
              data-toggle="modal"
              style={{ marginLeft: '10px' }}
            >
              Add Partner
            </div>
          </div>
          <div className="table-wrapper-scroll-y my-custom-scrollbar">
            <table className="table table-striped  table-bordered table-hover bg-white mt-1 mr-3">
              <thead className="bg-dark thead-dark">
                <tr>
                  <th className="text-center" style={{ width: '24%' }}>
                    Name
                  </th>
                  <th className="text-center " style={{ width: '9%' }}>
                    Activities
                  </th>
                  <th className="text-center permission-super-admin " style={{ width: '9%' }}>
                    Edit
                  </th>
                  <th className="text-center permission-super-admin " style={{ width: '9%' }}>
                    Remove
                  </th>
                </tr>
              </thead>
              <tbody>{this.renderpartners()}</tbody>
            </table>
          </div>
        </div>

        <AddPartnerModal />
        <EditPartnerModal />

        <div className="modal fade" id="deleteModal" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content" style={{ width: '80%', margin: '0 auto' }}>
              <div className="modal-header">
                <h5 className="modal-title">Are you Sure?</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    this.props.updateSelectedPartner(0);
                  }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body" style={{ textAlign: 'center', fontSize: '18px' }}>
                <strong>&apos;{this.getPartnerName()}&apos;</strong> will be deleted forever!!
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-dismiss="modal"
                  onClick={() => {
                    this.partnerDeleteRequest(this.props.selectedPartner);
                    this.props.updateSelectedPartner(0);
                  }}
                >
                  Yes
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  onClick={() => {
                    this.props.updateSelectedPartner(0);
                  }}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  partners: state.admin.admin.partners,
  partnerFilter: state.admin.partners.partnerFilter,
  selectedPartner: state.admin.partners.selectedPartner,
  employeeToken: state.auth.employeeToken
});

export default connect(mapStateToProps, {
  updatePartnerFilter,
  updateSelectedPartner
})(Partners);
